export default {
    methods: {
        GetHostel: function() {
            this.onloader = "flex";
            this.$store
              .dispatch("hostel/GetHostel")
              .then(resp => {
                this.HostelItems = resp;
                this.onloader = "none";
              })
              .catch(err => {
                this.onloader = "none";
                this.checkresponse(err.response.data);
              });
          },
    },
    mounted () {
      this.GetHostel()
    }
  }